import { render } from "./ThreeDObjectPropsCmp.vue?vue&type=template&id=23abb973"
import script from "./ThreeDObjectPropsCmp.vue?vue&type=script&lang=js"
export * from "./ThreeDObjectPropsCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__